import {Directive, forwardRef, Input, OnChanges, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Observable} from 'rxjs';
import {TypedSimpleChanges} from '../../../common/typed-on-changes';
import {
    AutocompleteConfig,
    AutocompleteDirective,
    AutocompleteProviderConfig,
    AutocompleteSearchType
} from '../../autocomplete';
import {DexWalletAutocompleteListComponent} from './dex-wallet-autocomplete-list.component';
import {DexWalletAutocompleteService} from './dex-wallet-autocomplete.service';

@Directive({
    selector: '[dexWalletAutocomplete]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DexWalletAutocompleteDirective),
            multi: true
        }
    ],
    standalone: false
})
export class DexWalletAutocompleteDirective extends AutocompleteDirective<string>
    implements ControlValueAccessor, OnChanges, OnInit {

    @Input('dexWalletAutocomplete')
    public inputConfig: AutocompleteConfig;

    public override listComponent: DexWalletAutocompleteListComponent;

    protected override readonly listComponentClass = DexWalletAutocompleteListComponent;

    protected readonly autocompleteProviderService = this.injector.get(DexWalletAutocompleteService);

    private autocompleteItems: string[];

    public ngOnChanges(changes: TypedSimpleChanges<DexWalletAutocompleteDirective>): void {
        if (changes.inputConfig && !changes.inputConfig.firstChange) {
            this.updateConfig();
        }
    }

    public override ngOnInit(): void {
        this.updateConfig();

        super.ngOnInit();
    }

    protected override getRawVariantsByTerm(term: string): Observable<string[]> {
        return this.autocompleteProviderService.autocomplete(
            term,
            this.config.type as AutocompleteProviderConfig<any>
        );
    }

    protected override transformRawVariants(items: string[]): string[] {
        this.autocompleteItems = items; // Store the raw autocomplete items in order to reuse it in the list component.

        return items;
    }

    protected override open(): void {
        super.open();

        this.listComponent.term$ = this.term$;
    }

    protected override setListComponentVariants(): void {
        this.listComponent.setVariants(this.variants, this.autocompleteItems);
    }

    private updateConfig(): void {
        const inputConfig = this.inputConfig || {};
        const inputConfigType: AutocompleteSearchType<string> = inputConfig.type;
        const filters = inputConfigType && (inputConfigType as AutocompleteProviderConfig<string>).filters
            || undefined;

        this.config = {
            freeTyping:                false,
            disallowEmptySelect:       true,
            selectAllOnFocus:          true,
            allowVariantsForEmptyTerm: true,

            ...inputConfig,

            type: {
                filters,
                provider: this.autocompleteProviderService
            },

            displayValue: (addr: string) => addr
        };
    }

}
